import { ConfigService } from '../config-service/config-service';
import { ConfigKey } from '../constants/config-key.constants';


function checkConfigService(): void {
	if (!ConfigService.instance) {
		throw new Error('ConfigLayerModule has not been added to the app module');
	}
}

export function InjectConfig(configKey: ConfigKey): PropertyDecorator {
	const PREFIX = '__$$';

	return (target: any, propertyKey: string) => {
		Object.defineProperty(target, propertyKey, {
			set: value => {
				checkConfigService();
				target[PREFIX + propertyKey] = ConfigService.instance.get(configKey, value) ?? value;
			},
			get: () => {
				checkConfigService();
				return ConfigService.instance.get(configKey, target[PREFIX + propertyKey]);
			},
			enumerable: true,
			configurable: true
		});
	};
}
